import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';

@Component({
  selector: 'app-drawing-receipt',
  templateUrl: './drawing-receipt.component.html',
  styleUrls: ['./drawing-receipt.component.css']
})
export class DrawingReceiptComponent implements OnInit {
myDate:any;
  contestId: any;
  images: any[];
  userId: any;
  drawingDetailsInfo: any;
  currency: any;
  ticketPrice: any;
  drawingBannerUrl: any;
  smallDesc: any;
  largeDesc: any;
  title: any;
  constructor(private datePipe: DatePipe,private service:HitmakerService,private service2:FilmServiceService,private activatedRoute: ActivatedRoute){
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');

  }
carouselOptions = {
  loop: true,
  items: 1,
  dots: false,
  nav: true,
  navText: ["<i class='bi bi-caret-left-fill'></i>","<i class='bi bi-caret-right-fill'></i>"],
  autoplay: false,
  autoplayTimeout: 4000, // Adjust autoplay speed
  responsive: {
    0: {
      items: 1,
      margin: 10,
    },
    768: {
      items: 2,
      margin: 20,
    },
    992: {
      items: 3,
      margin: 30,
    },
  },
};
  ngOnInit(): void {
    this.contestId = this.activatedRoute.snapshot.params['id'];

    this.service.getContestFilmDetails().subscribe((res:any)=>{
    console.log('response', res);
    this.images = [...res]
  })

  this.service2.getUserId().subscribe((res: any) => {
    this.userId = res.user;
  });
  this.getDrawingInfo();
}
  
 

  getDrawingInfo(){
    this.service2.getDrawingDetails(this.contestId).subscribe(res=>{
    
      console.log(res)
  this.drawingDetailsInfo = res;

  console.log(this.drawingDetailsInfo)
  console.log(this.drawingDetailsInfo.amountUserHas)
  console.log(this.drawingDetailsInfo.ticketPrice)
  console.log(this.drawingDetailsInfo.currentContest.customerImageUrl)

  this.currency = this.drawingDetailsInfo.amountUserHas;
  this.ticketPrice = this.drawingDetailsInfo.ticketPrice;
  this.drawingBannerUrl =this.drawingDetailsInfo.currentContest.customerImageUrl
this.smallDesc=this.drawingDetailsInfo.currentContest.smallDescription;
this.largeDesc=this.drawingDetailsInfo.currentContest.largeDescription;
this.title=this.drawingDetailsInfo.currentContest.name;


  
    })
   }
}
